export default __webpack_public_path__ + "static/media/2_trivago.6d0194c8.svg";